import { SimplePageHeader } from '@flexinet/ui-components';

export const TagsPageHeader = () => {
    return <SimplePageHeader title="Tags Management" tools={[]} />;
};

export const ContactsPageHeader = () => {
    return <SimplePageHeader title="Contacts Overview" tools={[]} />;
};

export const MessagesPageHeader = () => {
    return <SimplePageHeader title="Messages Overview" tools={[]} />;
};
